import { render, staticRenderFns } from "./ManageProjectReports.vue?vue&type=template&id=07088fd8&scoped=true"
import script from "./ManageProjectReports.vue?vue&type=script&lang=ts"
export * from "./ManageProjectReports.vue?vue&type=script&lang=ts"
import style0 from "./ManageProjectReports.vue?vue&type=style&index=0&id=07088fd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07088fd8",
  null
  
)

export default component.exports